<div class="py-1" role="group" aria-labelledby="primary-reporter-label">
  <span
    id="primary-reporter-label"
    class="font-lato text-xs font-semibold tracking-[0.06em] text-gray-400 uppercase"
    >Primary Reporter</span
  >

  <div class="mt-2 flex items-start gap-3">
    <!-- Initials avatar -->
    <div
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-100"
      aria-hidden="true"
    >
      <span class="font-lato text-sm font-bold text-slate-600">{{
        initials()
      }}</span>
    </div>

    <!-- Name + contact row -->
    <div class="min-w-0 flex-1">
      <div class="flex flex-wrap items-baseline gap-x-2">
        <span class="font-lato font-bold">
          {{ ticket().Contact.Name | titlecase }}</span
        >
        @if (ticket().Contact.Title) {
          <span class="font-lato text-xs font-normal text-gray-400 italic">{{
            ticket().Contact.Title | titlecase
          }}</span>
        }
      </div>

      <div
        class="mt-1 flex min-w-0 flex-col items-start gap-1 lg:flex-row lg:flex-wrap lg:items-center lg:gap-x-4 lg:gap-y-0.5"
      >
        @if (ticket().Contact.Phone) {
          <span class="font-lato flex min-w-0 items-center text-xs">
            <mat-icon class="!h-4 !w-4 !text-xs text-black" aria-hidden="true"
              >call</mat-icon
            >
            <a
              [href]="'tel:' + ticket().Contact.Phone"
              class="group font-lato flex min-w-0 items-center text-xs hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700"
              [attr.aria-label]="
                'Call ' + (ticket().Contact.Phone | phoneNumber: 'US')
              "
            >
              <span class="group-hover:underline">
                {{ ticket().Contact.Phone | phoneNumber: 'US' }}
              </span>
            </a>
          </span>
        }
        @if (ticket().Contact.Email) {
          <span class="font-lato flex min-w-0 items-center text-xs">
            <mat-icon class="!h-4 !w-4 !text-xs text-black" aria-hidden="true"
              >mail</mat-icon
            >
            <a
              [href]="'mailto:' + ticket().Contact.Email"
              class="min-w-0 break-all text-blue-700 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700"
              >{{ ticket().Contact.Email | lowercase }}</a
            >
          </span>
        }
      </div>
    </div>
  </div>
</div>
